import { useNavigate } from "@tanstack/react-router";
import Fade from "components/UI/Animations/Fade/Fade";
import ButtonAnimation from "components/UI/ButtonAnimation/ButtonAnimation";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import styles from "./Intro.module.scss";

export default function Intro() {
  const navigate = useNavigate();

  const handleJoyStick = (event: joystickEvent) => {
    if (event === "enter") {
      navigate({ to: "/uitleg" });
    }
  };

  useJoyStickNavigation(handleJoyStick);

  return (
    <Fade>
      <div className={styles.intro}>
        <div className={styles.inner}>
          <h1>Hoe gaat het met het welzijn in jouw buurt?</h1>
          <p>
            Onderzoekers van de Universiteit van Amsterdam hebben samen met
            bewoners gemeten wat zij belangrijk vinden. Over deze vijf
            onderwerpen willen we ook jou graag een aantal vragen stellen:
          </p>
          <div className={styles.iconsRow}>
            <img src="/images/icons/gelukEnLeven.svg" />
            <img src="/images/icons/werkEnKansen.svg" />
            <img src="/images/icons/mijnBuurt.svg" />
            <img src="/images/icons/activiteitenInDeBuurt.svg" />
            <img src="/images/icons/kwakuFestival.svg" />
          </div>
        </div>

        <div className={styles.buttonAnimationWrapper}>
          <div className={styles.buttonAnimation}>
            <ButtonAnimation />
            <p>Start enquête</p>
          </div>
        </div>
      </div>
    </Fade>
  );
}
